import { createSlice } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
import { first, groupBy, orderBy, sortBy, toLower, toUpper, uniqBy } from 'lodash';
import { API } from 'api';
import { getQueryParams } from 'utils';
import { setselectedSalesMan } from './userSlice';

const URL = process.env.REACT_APP_API_URL_V5;

const initialState = {
	SalesInvoices: [],
	SalesInvoicesFiltered: [],
	SalesRejectedInvoices: [],
	SalesRejectedInvoicesFiltered: [],
	newfilteredInvoices: [],
	dashboard: {},
	sales_dashboard: {
		bill_back: 1,
		no_bill_back: 1,
		cash: 0,
		neft: 0,
		upi: 0,
		cheque: 0,
		total: 0,
	},
	salesMen: [],
	salesMenSearch: '',
	invoiceSearch: '',
	salesMenDetail: '',
	checkAll: false,
	isAccordionOpen: false,
	isInvoiceOpen: false,
	brandCheckList: [],
	store_data: {},
	salesMenGrouped: {},
	can_salesman_edit: true,
	pastInvoiceState: true,
	reasons: [],
	billBackReasons: [],
};

function salesmanName(first_name = '') {
	return toUpper(toLower(first(first_name)));
}
function orderSalesMen(payload) {
	const orderedSalesMenList = orderBy(payload, ['first_name'], ['asc']);
	const groupedSalesMenList = groupBy(orderedSalesMenList, (man) =>
		salesmanName(man?.first_name)
	);
	const brandNames = uniqBy(payload, 'brand_name');

	return { orderedSalesMenList, groupedSalesMenList, brandNames };
}

function findValue(data, search) {
	/**
	 * change key and searched word to lower case and find the seached data
	 */
	return data?.toLowerCase()?.includes(search?.toLowerCase());
}

export function filterInvoices(invoices, search) {
	/**
	 * Find searched word in invoice store namd and invoice id
	 */
	// const storeName = invoices?.find(
	// 	(item) => item?.invoice_no.toLowerCase() === search.toLowerCase()
	// )?.store_name;

	// return invoices?.filter((item) =>
	// 	storeName ? findValue(item?.store_name, storeName) : findValue(item?.store_name, search)
	// );

	return invoices?.filter(
		(item) => findValue(item?.store_name, search) || findValue(item?.invoice_no, search)
	);
}

export const salesmanSlice = createSlice({
	name: 'salesman',
	initialState,
	reducers: {
		setSalesDashboard: (state, { payload }) => {
			state.dashboard = payload;
		},
		setSalesInvoices: (state, { payload }) => {
			/**
			 * For furture purpose added isOpen key to add invoices in local,
			 * for to show and hide the invoice form using redux,
			 * but currently not used this logic
			 */
			const data = sortBy(
				payload.map((item) => ({ ...item, isOpen: false })),
				['status']
			).reverse();

			state.SalesInvoices = data;
			state.SalesInvoicesFiltered = data;
		},
		setBanks: (state, { payload }) => {
			state.banks = payload;
		},
		setRejectedInvoices: (state, { payload }) => {
			/**
			 * For furture purpose added isOpen key to add invoices in local,
			 * for to show and hide the invoice form using redux,
			 * but currently not used this logic
			 */
			const data = sortBy(
				payload.map((item) => ({ ...item, is_rejected: true })),
				['status']
			).reverse();

			state.SalesRejectedInvoices = data;
			state.SalesRejectedInvoicesFiltered = data;
		},

		setSalesInvoiceOpen: (state, { payload }) => {
			state.isInvoiceOpen = payload;
		},
		setSalesDashboaZrd: (state, { payload }) => {
			state.dashboard = payload;
		},
		setSalesMenSearch: (state, { payload = '' }) => {
			state.salesMenSearch = payload;
		},
		setSalesMen: (state, { payload }) => {
			const { orderedSalesMenList, groupedSalesMenList, brandNames } = orderSalesMen(payload);

			state.salesMenGrouped = groupedSalesMenList;
			state.brandNames = brandNames;
			state.salesMen = orderedSalesMenList;
			state.filteredsalesMen = orderedSalesMenList;
		},
		setFilteredInvoices: (state, { payload }) => {
			const data = sortBy(payload, ['status']).reverse();

			state.SalesInvoicesFiltered = data;
		},
		setRejectFilteredInvoices: (state, { payload }) => {
			const data = sortBy(payload, ['status']).reverse();

			state.SalesRejectedInvoicesFiltered = data;
		},
		setPanelKey: (state, { payload }) => {
			state.panelKey = payload;
		},
		setInvoiceSearch: (state, { payload }) => {
			state.invoiceSearch = payload;
		},
		setIsAccordionOpen: (state, { payload }) => {
			state.isAccordionOpen = payload;
		},
		setBrandCheckList: (state, { payload }) => {
			if (state.brandCheckList.length > 0 && state.brandCheckList.includes(payload)) {
				state.brandCheckList = state.brandCheckList.filter(
					(brandId) => brandId !== payload
				);
				state.checkAll = false;
			} else {
				state.brandCheckList.push(payload);
			}
		},
		setAllBrandList: (state, { payload }) => {
			if (!state.checkAll && payload.length > 0) {
				state.brandCheckList = [];
				payload.map(
					(invoice) =>
						invoice.status === 'Pending' && state.brandCheckList.push(invoice.id)
				);
				state.checkAll = true;
			} else {
				state.brandCheckList = [];
				state.checkAll = false;
			}
		},
		setStoreInfo: (state, { payload }) => {
			state.store_data = payload;
		},
		setSalesMenDetail: (state, { payload }) => {
			state.salesMenDetail = payload;
		},
		clearCheckList: (state) => {
			state.brandCheckList = [];
			state.salesMenDetail = '';
			state.checkAll = false;
		},
		setFilteredSalesMen: (state, { payload }) => {
			const { orderedSalesMenList, groupedSalesMenList, brandNames } = orderSalesMen(payload);

			state.salesMenGrouped = groupedSalesMenList;
			state.brandNames = brandNames;
			state.filteredsalesMen = orderedSalesMenList;
		},
		brandBasedFilter: (state, { payload }) => {
			const filtered = state?.filteredsalesMen?.filter(
				(item) => item?.brand_id === Number(payload)
			);
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		setAdditionalFilter: (state, { payload }) => {
			state.additionalFilter = payload;
		},
		setReasons: (state, { payload }) => {
			state.reasons = payload;
		},
		setBillBackReasons: (state, { payload }) => {
			state.billBackReasons = payload;
		},
		setDenomination: (state, { payload }) => {
			state.denomination = payload;
		},
		setCanSaelesManEdit: (state, { payload }) => {
			state.can_salesman_edit = payload;
		},
		setChosenColor: (state, { payload }) => {
			state.chosenColor = payload;
		},
		setIsNoInvoicesMen: (state, { payload }) => {
			state.isNoInvoicesMen = payload;
		},
		singleStatusFilter: (state, { payload }) => {
			let filtered = [];

			// blue dot
			if (payload === 1) {
				filtered = state?.filteredsalesMen?.filter(
					(item) => item?.invoices > 0 && item?.invoices === item?.pending_invoices
				);
			}

			// orange dot
			if (payload === 2) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.invoices >= item?.completed_invoices &&
						item?.salesman_filled > 0 &&
						item?.invoices !== item?.salesman_filled
				);
			}

			// green dot
			if (payload === 3) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.invoices > 0 &&
						item?.invoices === item?.completed_invoices &&
						item?.invoices === item?.salesman_filled
				);
			}

			// red-border dot
			if (payload === 4) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.additional_resource_filled > 0 &&
						item?.salesman_filled === 0 &&
						item?.invoices !== item?.additional_resource_filled
				);
			}
			// red dot
			if (payload === 5) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.additional_resource_filled > 0 &&
						item?.invoices === item?.completed_invoices
				);
			}
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		getNoInvoiceMen: (state) => {
			const filtered = state?.filteredsalesMen?.filter((item) => item?.invoices === 0);
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		multipleStatusFilter: (state) => {
			const filtered = state?.filteredsalesMen?.filter(
				(item) =>
					item?.invoices !== 0 ||
					item?.pending_invoices !== 0 ||
					item?.completed_invoices !== 0
			);
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		setPastInvoices: (state, { payload }) => {
			state.pastInvoice = payload;
			if (payload.length === 0) {
				state.pastInvoiceState = false;
			} else {
				state.pastInvoiceState = true;
			}
		},
		clearPastInvoiceState: (state) => {
			state.pastInvoiceState = true;
		},
	},
});

export const {
	setSalesInvoices,
	setSalesInvoiceOpen,
	setSalesDashboard,
	setSalesMenSearch,
	setSalesMen,
	setFilteredInvoices,
	setRejectFilteredInvoices,
	setPanelKey,
	setInvoiceSearch,
	setIsAccordionOpen,
	setAllBrandList,
	setBrandCheckList,
	setStoreInfo,
	clearCheckList,
	setSalesMenDetail,
	setFilteredSalesMen,
	setRejectedInvoices,
	setAdditionalFilter,
	setBanks,
	setReasons,
	setBillBackReasons,
	setDenomination,
	setCanSaelesManEdit,
	setChosenColor,
	setIsNoInvoicesMen,
	singleStatusFilter,
	getNoInvoiceMen,
	multipleStatusFilter,
	brandBasedFilter,
	setPastInvoices,
	clearPastInvoiceState,
} = salesmanSlice.actions;

export const salesmanDashboardDetails = (salesmanId) => async (dispatch, getState) => {
	const invoice_date = getState()?.app?.invoiceDate;
	const salesmanIdTemp = getQueryParams('salesmanId');
	const CREDENTIALS = {
		url: `${URL}/dashboard/details`,
		queryParams: {
			invoice_date,
			salesman_id: salesmanId || salesmanIdTemp,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setSalesDashboard(response.data));

		return response;
	});
};

export const getSalesInvoicesList = (salesmanId) => async (dispatch, getState) => {
	dispatch(setInvoiceSearch(' '));
	const url = `${URL}/invoices/salesman/collections`;

	const collection_date = getState()?.app?.invoiceDate;
	const salesmanIdTemp = getQueryParams('salesmanId');

	const CREDENTIALS = {
		url,
		showLoading: true,
		queryParams: {
			collection_date,
			salesman_id: salesmanId || salesmanIdTemp,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);

		// let resultArray = Array.prototype.concat.apply(
		// 	response?.collections,
		// 	response?.collections
		// );

		dispatch(setSalesInvoiceOpen(false));
		dispatch(setSalesInvoices(response?.collections));
		dispatch(setFilteredInvoices(response?.collections));
		dispatch(salesmanDashboardDetails(salesmanId));
		dispatch(setRejectedInvoices(response?.rejected_collections));
		dispatch(setRejectFilteredInvoices(response?.rejected_collections));
		dispatch(setCanSaelesManEdit(response?.can_salesman_edit));

		return response;
	});
};

export const getStoreDetails = (storteId) => (dispatch, getState) => {
	const url = `${URL}/invoices/store/${storteId}/collections`;
	const invoice_date = getState()?.app?.invoiceDate;
	const salesmanIdTemp = getQueryParams('salesmanId');

	const CREDENTIALS = {
		url,
		queryParams: {
			collection_date: invoice_date,
			salesman_id: salesmanIdTemp,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);
		dispatch(setStoreInfo(response));

		return response?.data;
	});
};

export const getDeliveryDate = () => async (dispatch, getState) => {
	console.log(getState);
	const invoice_date = getState()?.app?.invoiceDate;
	const storeID = getQueryParams('storeId');
	const salesmanId = getQueryParams('salesmanId');
	let url;

	if (salesmanId) {
		url = `${URL}/invoices/collections/delivery-date?store_id=${storeID}&collection_date=${invoice_date}&salesman_id=${salesmanId}`;
	} else {
		url = `${URL}/invoices/collections/delivery-date?store_id=${storeID}&collection_date=${invoice_date}`;
	}

	const CREDENTIALS = {
		url,
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);

		return response;
	});
};

export const clearBillBack = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `${URL}/invoices/bill-back`,
		method: 'put',
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(getSalesInvoicesList());
		toaster.success('All Invoices Set as Bill Back');

		return response;
	});
};

export const getBanks = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `${URL}/banks`,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setBanks(response.data));

		return response;
	});
};

export const getReasons = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `${URL}/reasons`,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setReasons(response.data));

		return response;
	});
};

export const getBillBackReasons = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `${URL}/reasons/bill-back`,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setBillBackReasons(response.data));

		return response;
	});
};
export const saveInvoicesComplete = (values, setErrors) => async (dispatch, getState) => {
	dispatch(setSalesInvoiceOpen(false));

	console.log(values);

	// if (values?.previousStatus !== 'Pending' && !isAmortize) {
	// 	details = {
	// 		method: 'put',
	// 		message: 'updated',
	// 	};
	// }

	const CREDENTIALS = {
		url: `${URL}/invoices/complete`,
		method: 'post',
		data: values,
		setErrors,
	};

	return API.common(CREDENTIALS).then((response) => {
		const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

		dispatch(salesmanDashboardDetails(selectedSalesMan));

		return response;
	});
};

export const clearInvoiceID =
	(
		id,
		showSuccess = true,
		data = {
			payment: [],
			status: undefined,
		}
	) =>
	async (dispatch, getState) => {
		/**
		 * Clear invoice with single invoice id
		 */
		dispatch(setSalesInvoiceOpen(false));

		const values = { payment: [] };

		if (data?.payment?.length > 0) {
			values.payment = data?.payment;
			values.status = data?.status;
		}

		const CREDENTIALS = {
			url: `${URL}/invoices/${id}/clear`,
			method: 'put',
			data: values,
		};

		return API.common(CREDENTIALS).then((response) => {
			// dispatch(updateInvoices(response.data));
			const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

			dispatch(salesmanDashboardDetails(selectedSalesMan));
			if (showSuccess) {
				toaster.success('Invoice cleared');
			}

			return response;
		});
	};

export const submitPendingInvoice =
	(invoiceDate, sales_man_id, stores_id = [], showSuccess = true) =>
	// eslint-disable-next-line sonarjs/no-identical-functions
	async (dispatch, getState) => {
		/**
		 * Clear invoice with single invoice id
		 */
		dispatch(setSalesInvoiceOpen(false));

		const values = {
			collection_date: invoiceDate,
			store_id: stores_id,
			salesman_id: sales_man_id,
		};

		const CREDENTIALS = {
			url: `${URL}/invoices/updatedefault`,
			method: 'post',
			data: values,
		};

		// eslint-disable-next-line sonarjs/no-identical-functions
		return API.common(CREDENTIALS).then((response) => {
			// dispatch(updateInvoices(response.data));
			const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

			dispatch(salesmanDashboardDetails(selectedSalesMan));
			if (showSuccess) {
				toaster.success('updated successfully');
			}

			return response;
		});
	};

export const clearAllInvoices = (values) => async () => {
	/**
	 * New way to clear all invoices with single api call, in data we will send invoices ids
	 */
	const CREDENTIALS = {
		url: `${URL}/invoices/clear-all`,
		method: 'put',
		data: values,
	};

	return API.common(CREDENTIALS).then((response) => response);
};

export const clearStoreInvoices = (storeId, invoiceDate) => async () => {
	/**
	 * New way to clear all invoices with single api call, in data we will send invoices ids
	 * sdkjbfsjd
	 *
	 */

	const CREDENTIALS = {
		url: `${URL}/store/${storeId}/clear-collections`,
		method: 'put',
		queryParams: {
			collection_date: invoiceDate,
		},
	};

	return API.common(CREDENTIALS).then((response) => response);
};

export const getNewAmortizeLogic = (values) => async () => {
	/**
	 * Get amortize split data from Backend
	 */
	const CREDENTIALS = {
		url: `${URL}/invoices/amortize`,
		method: 'post',
		data: values,
	};

	return API.common(CREDENTIALS).then((response) => response);
};

export const saveInvoice =
	(id, values, setErrors, isAmortize = false) =>
	async (dispatch, getState) => {
		dispatch(setSalesInvoiceOpen(false));
		let details = {
			method: 'post',
			message: 'saved',
		};

		/**
		 * on Amortization don't make api call as put call
		 */
		if (values?.previousStatus !== 'Pending' && !isAmortize) {
			details = {
				method: 'put',
				message: 'updated',
			};
		}

		const CREDENTIALS = {
			url: `${URL}/invoices/complete`,
			method: details.method,
			data: values,
			setErrors,
		};

		return API.common(CREDENTIALS).then((response) => {
			// dispatch(updateInvoices(response.data));
			const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

			dispatch(salesmanDashboardDetails(selectedSalesMan));
			if (!isAmortize) {
				toaster.success(`Invoice ${details.message} success`);
			}

			return response;
		});
	};

export function filterSalesMen(salesMen, search) {
	/**
	 * Find searched word in sales men name and mobile number or in invoice numbers
	 */
	return salesMen?.filter(
		(item) =>
			findValue(item?.first_name, search) ||
			findValue(item?.mobile, search) ||
			findValue(item?.invoice_numbers, search)
	);
}

export const getSalesMen =
	(clearselectedSalesMan = false) =>
	async (dispatch, getState) => {
		const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

		/**
		 * Before sales men list call, reset already selected sales man
		 */
		if (clearselectedSalesMan) {
			dispatch(setselectedSalesMan({}));
		}
		const CREDENTIALS = {
			url: `${URL}/sales-men`,
			queryParams: {
				salesman_id: selectedSalesMan,
			},
		};

		return API.common(CREDENTIALS).then((response) => {
			dispatch(setSalesMenSearch(''));
			console.log(response, 'response');
			dispatch(setSalesMen(response.data));

			return response;
		});
	};

export const getAlreadyPaidUPIList =
	({ store_id, salesmanId }) =>
	async () => {
		console.log('salesmanId', salesmanId);
		console.log('store_id', store_id);

		const CREDENTIALS = {
			url: `${URL}/invoices/upi-list`,
			method: 'get',
			queryParams: {
				store_id,
				salesman_id: salesmanId,
			},
		};

		return API.common(CREDENTIALS).then((response) => response);
	};

export const final_submit =
	(salesmanId, invoiceDate, showSuccess = true) =>
	async (dispatch) => {
		console.log(salesmanId, invoiceDate);
		const CREDENTIALS = {
			url: `${URL}/invoices/final_submit`,
			method: 'put',
			data: {
				salesman_id: salesmanId,
				collection_date: invoiceDate,
			},
		};

		return API.common(CREDENTIALS).then((response) => {
			dispatch(getSalesInvoicesList());

			if (showSuccess) {
				toaster.success('Successful');
			}

			return response;
		});
	};

export const saveDenominations = (values) => async (dispatch) => {
	const CREDENTIALS = {
		url: `${URL}/denominations`,
		method: 'post',
		data: values,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setDenomination(response.data));
		toaster.success('Denomination updated');

		return response;
	});
};
export const getDenominations = (salesmanId) => async (dispatch, getState) => {
	const url = salesmanId ? `/denominations?salesman_id=${salesmanId}` : '/denominations';
	const invoice_date = getState()?.app?.invoiceDate;

	const CREDENTIALS = {
		url: `${URL}${url}`,
		queryParams: {
			invoice_date,
			salesman_id: salesmanId,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setDenomination(response.data));

		return response;
	});
};
export const makeAllBillBack = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `${URL}/invoices/bill-back`,
		method: 'put',
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(getSalesInvoicesList());
		console.log('makeAllBillBack');
		toaster.success('All Invoices Set as Bill Back');

		return response;
	});
};
export const getUpiReferenceNumbers =
	({ store_id, salesman_id, query, amount }) =>
	async () => {
		const CREDENTIALS = {
			url: `${URL}/online-transactions`,
			queryParams: {
				amount,
				query,
				store_id,
				salesman_id,
				type: 'UPI',
			},
		};

		return API.common(CREDENTIALS).then((response) => response.data);
	};

export const updatePastInvoice = (data) => async () => {
	const CREDENTIALS = {
		url: `${URL}/invoices/past`,
		method: 'post',
		data: { invoice_id: data },
	};

	return API.common(CREDENTIALS).then((response) => response);
};
export const searchPastInvoice = (data) => async (dispatch, getState) => {
	const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

	const CREDENTIALS = {
		url: `${URL}/invoices/past`,
		queryParams: {
			invoice_number: data,
			salesman_id: selectedSalesMan,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		if (response.data.length > 0) {
			dispatch(updatePastInvoice(response?.data[0]?.id));
		}
		dispatch(setPastInvoices(response?.data));

		return response;
	});
};

export default salesmanSlice.reducer;
